export default __webpack_public_path__ + "static/media/LAIN21.XA[16].90080735.mp4";